var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-fade-transition', {
    attrs: {
      "group": "",
      "origin": "center center 0",
      "leave-absolute": ""
    }
  }, [_c('modify-login', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showLogin,
      expression: "showLogin"
    }],
    key: "login"
  }), _c('modify-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showForm,
      expression: "showForm"
    }],
    key: "form"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }